
export default {
  name: 'AppModalHeader',
  props: {
    title: {
      type: String,
      default: ''
    },
    showBackButton: {
      type: Boolean,
      default: false
    },
    showCloseButton: {
      type: Boolean,
      default: false
    }
  }
};
